import React from 'react';
import Api from '../../api/api';
import Notice from '../../components/notices/notice';
import Loading from '../../components/loading/loading';
import { SERVER_ERROR } from '../../constants/messages';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';


export default class ContactForm extends React.Component {
  constructor() {
    super();
    this.formRef = React.createRef();
    this.nameRef = React.createRef();
    this.subjectRef = React.createRef();
    this.emailRef = React.createRef();
    this.messageRef = React.createRef();
    this.captchaRef = React.createRef();
    this.captcha = Api.captcha();
    this.state = {
      success: false,
      clientError: false,
      serverError: false,
      error_messages: [],
      loading: false
    };
  }

  validateInput(data) {
    const error_messages = [];

    if (+data.captcha != this.captcha.result) {
      error_messages.push("That answer isn't right, please try again");
    }

    if (Api.hasEmptyFields(data)) {
      error_messages.push('Please fill in all the required fields');
    }

    return error_messages;
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true });

    const name = this.nameRef.current.value;
    const subject = this.subjectRef.current.value;
    const email = this.emailRef.current.value;
    const message = this.messageRef.current.value;
    const captcha = this.captchaRef.current.value;
    const data = { name, email, message };
    const error_messages = this.validateInput(Object.assign({}, data, { captcha }));

    if (error_messages.length) {
      return this.setState({
        clientError: true,
        success: false,
        serverError: false,
        loading: false,
        error_messages
      });
    }

    data['subject'] = subject || 'General Query';

    this.sendForm(data);
  }

  sendForm(data) {
    Api.sendContact(data, {
      onSuccess: ({ data }) => {
        this.formRef.current.reset();
        this.setState({
          success: true,
          clientError: false,
          serverError: false,
          loading: false
        });
        console.log('[PostHog] Capturing CONTACT_FORM_SUBMITTED');
        PostHogService.capture(PostHogEvents.CONTACT_FORM_SUBMITTED);
      },
      onError: () => {
        this.setState({
          serverError: true,
          success: false,
          clientError: false,
          loading: false
        });
      }
    });
  }

  renderNotice() {
    if (this.state.success) {
      return <Notice type="success">Thanks for getting in touch! We'll get back to you as soon as possible.</Notice>;
    }
    if (this.state.serverError) {
      return <Notice type="error">{SERVER_ERROR}</Notice>;
    }
    if (this.state.clientError) {
      const messages = this.state.error_messages;
      return (
        <Notice type="error">
          {messages.length === 1 ? messages[0] : <ul>{messages.map((message) => <li key={message}>{message}</li>)}</ul>}
        </Notice>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="contact-card">
        {(this.state.loading) ? <Loading text="Please wait..." /> : null}
        <h2 className="contact-card-title">Send us a message</h2>

        {this.renderNotice()}

        <form ref={this.formRef} onSubmit={this.handleSubmit.bind(this)}>
          <div className="contact-form-row">
            <div className="input-group">
              <label className="input-label" htmlFor="contact_name">Name <span className="contact-required">*</span></label>
              <input ref={this.nameRef} id="contact_name" className="input-field" type="text" name="name" autoComplete="name" required />
            </div>
            <div className="input-group">
              <label className="input-label" htmlFor="contact_email">Email <span className="contact-required">*</span></label>
              <input ref={this.emailRef} id="contact_email" className="input-field" type="email" name="email" autoComplete="email" required />
            </div>
          </div>

          <div className="input-group">
            <label className="input-label" htmlFor="contact_subject">Subject</label>
            <input ref={this.subjectRef} id="contact_subject" className="input-field" type="text" name="subject" />
          </div>

          <div className="input-group">
            <label className="input-label" htmlFor="contact_message">Message <span className="contact-required">*</span></label>
            <textarea ref={this.messageRef} id="contact_message" className="input-field contact-textarea" name="message" rows="6" required />
          </div>

          <div className="input-group">
            <label className="input-label" htmlFor="contact_captcha">To show you're human, what is {this.captcha.leftside} + {this.captcha.rightside}? <span className="contact-required">*</span></label>
            <input ref={this.captchaRef} id="contact_captcha" className="input-field contact-captcha" type="text" inputMode="numeric" autoComplete="off" name="captcha" required />
          </div>

          <div className="contact-actions">
            <button className="btn btn-primary-sm" type="submit">Send message</button>
          </div>
        </form>
      </div>
    )
  }
}
